import cx from 'classnames';
import { ReactNode, useState } from 'react';

import { ArrowDropDown } from '../Icons/ArrowDropDown';

import s from './ExpandableContainer.css';

interface Props {
    previewTitle: string | ReactNode;
    content: ReactNode;
    classNameContainer?: string;
    classNameButton?: string;
    onClickOnExpand?: (isExpanded: boolean) => void;
}

export const ExpandableContainer = ({
    previewTitle,
    content,
    classNameContainer,
    classNameButton,
    onClickOnExpand,
}: Props) => {
    const [showContent, setShowContent] = useState(false);

    return (
        <div className={cx(classNameContainer, s.expandableContainer)}>
            <div
                className={cx(s.expandableHeader, {
                    [s.expanded]: showContent,
                })}
                onClick={() => {
                    if (onClickOnExpand) onClickOnExpand(!showContent);
                    setShowContent(!showContent);
                }}
            >
                <div className="badge">{previewTitle}</div>
                <button
                    type="button"
                    className={cx(classNameButton, s.collapse, {
                        [s.rotateAnimation]: showContent,
                    })}
                >
                    <ArrowDropDown />
                </button>
            </div>
            <div
                className={cx(s.expandedBody, {
                    [s.showContentAnimation]: showContent,
                })}
            >
                {content}
            </div>
        </div>
    );
};
